<div id="search-box-title">
	<p class="search-box-title-with-geolocation search-box-title-hidden center">Folose&#x219;te loca&#539;ia ta pentru a g&#259;si cel mai apropiat magazin Orange</p>
	<p class="search-box-title-without-geolocation search-box-title-hidden center">G&#259;se&#x219;te cel mai apropiat magazin Orange</p>
</div>